import React from 'react';
import Card from 'components/fullWidthCard';
import {FormattedMessage, intlShape, injectIntl} from 'react-intl';
import Modal, {modalSizes} from 'components/layout/modal';
import hopscotch from 'hopscotch';
import {dealerAdminTourFormat} from 'helpers/constants';

class DeviceTools extends React.Component {
  static propTypes = {
    intl: intlShape.isRequired,
  };

  state = {
    downTermsVisible: false,
  };

  componentDidMount() {
    if (hopscotch.getState() === 'dealerAdmin:17') {
      hopscotch.startTour(dealerAdminTourFormat(this.props.intl.formatMessage), 17);
    }
  }

  componentWillUnmount() {
    if (hopscotch.isActive && window.location.hash !== '#support' && window.location.hash !== '#settings/water-analysis') {
      hopscotch.endTour();
    }
  }

  closeDownloadModal = () => {
    this.setState({downTermsVisible: false});
  };

  download = () => {
    location.href = '/Content/ALEXPro.zip';
    this.closeDownloadModal();
  };

  goToPage = (pathName) => {
    window.location.href = pathName;
  };

  openDownloadModal = () => {
    this.setState({downTermsVisible: true});
  };

  render() {
    let {formatMessage} = this.props.intl;

    return <div className='container scanner-tools'>
      <Card title={formatMessage({id: 'tools.device.calibration'})}
            link='#tools/calibration'
            onTitleClick={this.goToPage}
            right={<a className='btn btn-primary pull-right'
                      href='#tools/calibration'><FormattedMessage id="tools.start.calibration"/></a>}
            body={formatMessage({id: 'tools.calibration.description'})}/>
      <Card title={formatMessage({id: 'tools.alex.test.connect'})}
            onTitleClick={this.openDownloadModal}
            right={<button className='btn btn-primary pull-right download-package'
                           onClick={this.openDownloadModal}><FormattedMessage id="tools.download.package"/></button>}
            body={formatMessage({id: 'tools.test.connect.description'})}/>
      {this.state.downTermsVisible ? <Modal onClose={this.closeDownloadModal}
                                            size={modalSizes.small}>
        <div>
          <p style={{marginBottom: 15}}><FormattedMessage id="tools.connect.description" values={{
            terms: <a href="#terms-of-service"
                      target="_blank"><FormattedMessage id="general.terms.use"/></a>,
            site: 'alex.mybioguard.com',
          }}/>
          </p>
          <button className='btn btn-default'
                  onClick={this.closeDownloadModal}><FormattedMessage id="general.cancel"/></button>
          <button className='btn btn-primary pull-right'
                  onClick={this.download}><FormattedMessage id="tools.download.package"/></button>
        </div>
      </Modal> : null}
    </div>;
  }
}

export default injectIntl(DeviceTools);
